import React from 'react';
import Page from '../../Components/Page';
import './style.scss';

function ChargingStatus() {
  return <Page title='Charging Status'>NO DATA</Page>;
}

export default ChargingStatus;
